import React from "react"
import Modal from "react-modal"

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    minHeight: "30%",
    height: "75svh",
    minWidth: "580px",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "stretch",
    padding: 0,
    overflow: "visible", // makes the close button appear out of the Modal
  },
  overlay: {
    overflow: "auto",
    transition: "(top 0.4s, opacity 0.4s)",
    zIndex: 1003,
    background: "rgba(0, 0, 0, 0.4)",
  },
}

type ModalContainerProps = {
  isOpen: boolean
  closeModal: () => void
  Header: React.ReactNode
  children: React.ReactNode
}
export function ModalContainer(props: ModalContainerProps): JSX.Element {
  const { isOpen, closeModal, Header, children } = props

  return (
    <>
      {/* @ts-ignore */}
      <Modal
        isOpen={isOpen}
        onRequestClose={closeModal}
        // @ts-ignore
        style={customStyles}
      >
        <button
          type="button"
          className="close"
          onClick={closeModal}
          style={{
            position: "absolute",
            right: "-35px",
            top: "-40px",
            opacity: 0.8,
            backgroundColor: "rgba(255,255,255,0.5)",
            width: "35px",
            height: "35px",
            borderRadius: "50%",
            display: "flex",
            placeItems: "center",
          }}
        >
          <span
            style={{
              fontSize: "50px",
              color: "black",
              margin: 0,
              marginLeft: "5px",
              padding: 0,
            }}
          >
            &times;
          </span>
        </button>
        <div className="modal-content" style={{ height: "100%" }}>
          <div className="modal-header" style={{ position: "relative" }}>
            {Header}
          </div>
          <div
            style={{
              overflowY: "scroll",
              height: "100%",
            }}
            className={`modal-body`}
          >
            {children}
          </div>
        </div>
      </Modal>
    </>
  )
}
